import type { CreateLabTestInput, LabTest } from '#shared/types';

const EMPTY_LAB_TEST: CreateLabTestInput = {
  name: '',
  code: '',
  price: 0,
  turnaround_hours: null,
  comment: '',
  sample_instructions: '',
  department_id: null,
  default_consultant_id: null,
  report_kind: 'parameters',
  parameter_ids: [],
  antibiotic_ids: [],
};

/** The form's starting values: the saved test when editing, blanks when creating. */
export function initialLabTestValues(record?: LabTest): CreateLabTestInput {
  if (!record) return EMPTY_LAB_TEST;
  return {
    name: record.name,
    code: record.code,
    price: record.price,
    turnaround_hours: record.turnaround_hours,
    comment: record.comment ?? '',
    sample_instructions: record.sample_instructions ?? '',
    department_id: record.department_id,
    default_consultant_id: record.default_consultant_id,
    report_kind: record.report_kind,
    parameter_ids: record.parameters.map((parameter) => parameter.id),
    antibiotic_ids: record.antibiotics.map((antibiotic) => antibiotic.id),
  };
}

/**
 * What the form submits: only the list its report type uses. Both are kept in
 * the form while the type is toggled, so switching back loses nothing.
 */
export function submittedLabTest(values: CreateLabTestInput): CreateLabTestInput {
  const culture = values.report_kind === 'culture';
  return {
    ...values,
    parameter_ids: culture ? [] : values.parameter_ids,
    antibiotic_ids: culture ? values.antibiotic_ids : [],
  };
}

/** '' is the "not set" option; the field is nullable on both sides. */
export function choiceToId(choice: string): number | null {
  return choice === '' ? null : Number(choice);
}

export function idToChoice(id: number | null | undefined): string {
  return id == null ? '' : String(id);
}
